var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEndpoint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#4285f4;}.cls-2{fill:#aecbfa;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon_24px_Endpoints_Color") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Product Icons"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "colored-32/endpoints"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "15 10 9 10 8 12 9 14 15 14 16 12 15 10"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape-2",
    "data-name": "Shape",
    className: "cls-2",
    points: "16 12 15 10 9.51 10 9 10 8 12 16 12"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "18 6 15 6 18.97 12 20.47 9.75 18 6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "21.95 12 20.47 9.75 18.97 12 18.97 12 15 18 18 18 21.95 12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "5.95 18 8.95 18 4.98 12 3.48 14.25 5.95 18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "2 12 3.48 14.25 4.98 12 4.98 12 8.95 6 5.95 6 2 12"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndpoint);
export default __webpack_public_path__ + "static/media/endpoint.265555932860eabd3f1843b9ab16bd95.svg";
export { ForwardRef as ReactComponent };